import * as React from 'react';

export default function MinusBlack({
  className,
  viewBox = '0 0 20 20',
  ...rest
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="16" height="16" viewBox={viewBox} fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Minus">
        <path
          id="Icon"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M2.3999 8.00313C2.3999 7.79095 2.48419 7.58747 2.63422 7.43744C2.78425 7.28741 2.98773 7.20312 3.1999 7.20312H12.7999C13.0121 7.20312 13.2156 7.28741 13.3656 7.43744C13.5156 7.58747 13.5999 7.79095 13.5999 8.00313C13.5999 8.2153 13.5156 8.41878 13.3656 8.56881C13.2156 8.71884 13.0121 8.80313 12.7999 8.80313H3.1999C2.98773 8.80313 2.78425 8.71884 2.63422 8.56881C2.48419 8.41878 2.3999 8.2153 2.3999 8.00313Z"
          fill="#0F0F10"
        />
      </g>
    </svg>
  );
}
